import React, { useState, useEffect } from 'react';
import { uiColors } from '../../common/styles';
import styled from 'styled-components/macro';

const Timer = styled.span`
    color: ${(props) => props.$color ? props.$color : uiColors.WHITE};
`;

const FramiCountdownTimer = ({ targetDate, onCountdownEnd, color }) => {
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    const formatNumber = (number) => String(number).padStart(2, '0');

    function calculateTimeLeft() {
        const difference = new Date(targetDate) - new Date();
        if (difference > 0) {
            return {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / (1000 * 60)) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        } else {
            return null;
        }
    }

    useEffect(() => {
        const timer = setInterval(() => {
            const newTimeLeft = calculateTimeLeft();
            setTimeLeft(newTimeLeft);

            if (!newTimeLeft) {
                clearInterval(timer);
                if (onCountdownEnd) onCountdownEnd();
            }

        }, 1000);

        return () => clearInterval(timer);
    }, [targetDate, onCountdownEnd]);

    if (!timeLeft) {
        return null
    }

    return (
        <Timer $color={color}>&nbsp;
            {timeLeft.days > 0 ? `${timeLeft.days}d : ` : ''}{formatNumber(timeLeft.hours)} : {formatNumber(timeLeft.minutes)} : {formatNumber(timeLeft.seconds)}
        </Timer>
    );
};

export default FramiCountdownTimer;
